<template>
  <div class="-text--color-danger -mvl -phd">
    <p><strong>{{ $t('js.path.destroy_warning') }}</strong></p>
    <ul>
      <li>{{ $t('js.path.destroy_warning_lines1') }}</li>
      <li>{{ $t('js.path.destroy_warning_lines2') }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'GpaPathDestroyWarning',
}
</script>
